import { takeLatest, call, all, select } from 'redux-saga/effects';
import configSelector from '../config/selector';

// SERVERS
import Types from './types';
import GlobalTypes from '../globalTypes';

import { fetchAsync as ticketFetchAsync } from './states/tickets/saga';
import { fetchAsync as serversFetchAsync } from './states/servers/saga';


function* fetchStartAsync() {
    const config = yield select(configSelector);
    yield call(ticketFetchAsync, config.date);
    yield call(serversFetchAsync, config.date);
}

function* fetchStart() {
    yield takeLatest(Types.FETCH_START, fetchStartAsync);
    yield takeLatest(GlobalTypes.DATE_DID_CHANGE, fetchStartAsync);
}

export default function* sagas() {
    yield all([
        call(fetchStart),
    ]);
}